import {createAction} from 'redux-act';

export const GET_TODAY_TOTAL_SALES = createAction(
  'mainPage/GET_TODAY_TOTAL_SALES'
);
export const GET_TODAY_TOTAL_SALES_SUCCESS = createAction(
  'mainPage/GET_TODAY_TOTAL_SALES_SUCCESS'
);
export const SET_LOADING_TODAY_TOTAL_SALES = createAction(
  'mainPage/SET_LOADING_TODAY_TOTAL_SALES'
);
export const GET_YESTERDAY_TOTAL_SALES = createAction(
  'mainPage/GET_YESTERDAY__TOTAL_SALES'
);
export const GET_YESTERDAY_TOTAL_SALES_SUCCESS = createAction(
  'mainPage/GET_YESTERDAY__TOTAL_SALES_SUCCESS'
);
export const SET_LOADING_YESTERDAY_TOTAL_SALES = createAction(
  'mainPage/SET_LOADING_YESTERDAY__TOTAL_SALES'
);
export const GET_ALL_PERIOD_TOTAL_SALES = createAction(
  'mainPage/GET_ALL_PERIOD_TOTAL_SALES'
);
export const GET_ALL_PERIOD_TOTAL_SALES_SUCCESS = createAction(
  'mainPage/GET_ALL_PERIOD_TOTAL_SALES_SUCCESS'
);
export const GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES = createAction(
  'mainPage/GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES'
);
export const GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES_SUCCESS = createAction(
  'mainPage/GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES_SUCCESS'
);
export const SET_LOADING_ALL_PERIOD_TOTAL_SALES = createAction(
  'mainPage/SET_LOADING_ALL_PERIOD_TOTAL_SALES'
);

export const GET_ALL_PERIOD_CUSTOMERS_COUNT = createAction(
  'mainPage/GET_ALL_PERIOD_CUSTOMERS_COUNT'
);
export const GET_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS = createAction(
  'mainPage/GET_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS'
);
export const GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT = createAction(
  'mainPage/GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT'
);
export const GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS = createAction(
  'mainPage/GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS'
);
export const SET_LOADING_ALL_PERIOD_CUSTOMERS_COUNT = createAction(
  'mainPage/SET_LOADING_ALL_PERIOD_CUSTOMERS_COUNT'
);

export const GET_SALES_PER_HOUR = createAction('mainPage/GET_SALES_PER_HOUR');
export const GET_SALES_PER_HOUR_SUCCESS = createAction(
  'mainPage/GET_SALES_PER_HOUR_SUCCESS'
);
export const SET_LOADING_SALES_PER_HOUR = createAction(
  'mainPage/SET_LOADING_SALES_PER_HOUR'
);

export const GET_SALES_PER_ITEM = createAction('mainPage/GET_SALES_PER_ITEM');
export const GET_SALES_PER_ITEM_SUCCESS = createAction(
  'mainPage/GET_SALES_PER_ITEM_SUCCESS'
);
export const SET_LOADING_SALES_PER_ITEM = createAction(
  'mainPage/SET_LOADING_SALES_PER_ITEM'
);

export const GET_TOP_CUSTOMERS = createAction('mainPage/GET_TOP_CUSTOMERS');
export const GET_TOP_CUSTOMERS_SUCCESS = createAction(
  'mainPage/GET_TOP_CUSTOMERS_SUCCESS'
);
export const SET_LOADING_TOP_CUSTOMERS = createAction(
  'mainPage/SET_LOADING_TOP_CUSTOMERS'
);

export const GET_INSIGHTS_PERFORMANCE = createAction(
  'mainPage/GET_INSIGHTS_PERFORMANCE'
);
export const GET_INSIGHTS_PERFORMANCE_SUCCESS = createAction(
  'mainPage/GET_INSIGHTS_PERFORMANCE_SUCCESS'
);
export const GET_PREV_WEEK_INSIGHTS_PERFORMANCE = createAction(
  'mainPage/GET_PREV_WEEK_INSIGHTS_PERFORMANCE'
);
export const GET_PREV_WEEK_INSIGHTS_PERFORMANCE_SUCCESS = createAction(
  'mainPage/GET_PREV_WEEK_INSIGHTS_PERFORMANCE_SUCCESS'
);
export const SET_LOADING_INSIGHTS_PERFORMANCE = createAction(
  'mainPage/SET_LOADING_INSIGHTS_PERFORMANCE'
);

export const GET_EMAIL_MARKETING_STATS = createAction(
  'mainPage/GET_EMAIL_MARKETING_STATS'
);
export const GET_EMAIL_MARKETING_STATS_SUCCESS = createAction(
  'mainPage/GET_EMAIL_MARKETING_STATS_SUCCESS'
);
export const SET_LOADING_EMAIL_MARKETING_STATS = createAction(
  'mainPage/SET_LOADING_EMAIL_MARKETING_STATS'
);

export const GET_SURVEY_STATS = createAction('mainPage/GET_SURVEY_STATS');
export const GET_SURVEY_STATS_SUCCESS = createAction(
  'mainPage/GET_SURVEY_STATS_SUCCESS'
);
export const SET_LOADING_SURVEY_STATS = createAction(
  'mainPage/SET_LOADING_SURVEY_STATS'
);

export const GET_SURVEY_STATS_THIS_WEEK = createAction(
  'mainPage/GET_SURVEY_STATS_THIS_WEEK'
);
export const GET_SURVEY_STATS_THIS_WEEK_SUCCESS = createAction(
  'mainPage/GET_SURVEY_STATS_THIS_WEEK_SUCCESS'
);

export const CLEAR_MAIN_PAGE_DATA = createAction(
  'mainPage/CLEAR_MAIN_PAGE_DATA'
);

export const SET_OPEN_MODAL = createAction('mainPage/SET_OPEN_MODAL');
export const SETUP_CALL = createAction('mainPage/SETUP_CALL');

export const GET_MANAGE_PRICE_URL = createAction(
  'mainPage/GET_MANAGE_PRICE_URL'
);
export const GET_MANAGE_PRICE_URL_SUCCESS = createAction(
  'mainPage/GET_MANAGE_PRICE_URL_SUCCESS'
);
export const SET_LOADING_GROWTH_INFO = createAction(
  'mainPage/SET_LOADING_GROWTH_INFO'
);

export const GET_ANALYTICS_INFO = createAction('mainPage/GET_ANALYTICS_INFO');
export const GET_ANALYTICS_INFO_SUCCESS = createAction(
  'mainPage/GET_ANALYTICS_INFO_SUCCESS'
);
export const SET_LOADING_ANALYTICS_INFO = createAction(
  'mainPage/SET_LOADING_ANALYTICS_INFO'
);
